// Builds imgix URLs for images in the lavish-locations GCS bucket.
//
// imgix bills every distinct URL it renders (1 credit per 500 renders), and most of our
// bill is renders. Keep this in step with website/plugins/imgix.js: when the CMS builds
// exactly the same URLs as the website, they share the website's cached renders.
export const IMGIX_BASE = 'https://lavish-locations.imgix.net/';
const WIDTHS = [100, 200, 500, 800, 1600, 2400];

export function imgixUrl(filename, width, params = {}) {
  // Round up to the nearest standard width rather than creating a new variant.
  const w = WIDTHS.find(standard => standard >= width) || WIDTHS[WIDTHS.length - 1];
  // Object.assign, not spread: the CMS's Babel 6 setup can't parse object spread.
  const query = Object.entries(Object.assign({w, auto: 'format,compress'}, params))
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  return `${IMGIX_BASE}${filename}?${query}`;
}



// WEBPACK FOOTER //
// ./src/imgix.js